export default "__VITE_ASSET__DXFT6Ma6__"